import { TaskOutputReferenceInput } from '@automata/wfb-api/src/apis/wfbApiSchemas';

export function ok<Data>(data: Data): { isError: false; data: Data } {
  return { isError: false, data };
}

export function err<Errors>(errors: Errors): { isError: true; errors: Errors } {
  return { isError: true, errors };
}

export const isConnectorRef = (val: unknown): val is TaskOutputReferenceInput =>
  !!val && typeof val === 'object' && 'task_id' in val && 'output_name' in val;
